// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"597fa5a7","520":"3cb8621e"}[chunkId] + ".chunk.js";
};